import { PortableTextComponentProps } from '@portabletext/react';
import type { ToolkitPortableTextList } from '@portabletext/toolkit';
import styles from './List.module.scss';

export const BulletList = ({ children }: PortableTextComponentProps<ToolkitPortableTextList>) => (
  <ul className={styles.list}>{children}</ul>
);

export const NumberedList = ({ children }: PortableTextComponentProps<ToolkitPortableTextList>) => (
  <ol className={styles.list}>{children}</ol>
);
